<template>
  <div class="panel-body">
    <v-card>
      <template>
        <v-container>
          <v-row>
            <v-card>
            Group Inclusion
            </v-card>
          </v-row>
          <v-row>
            <v-col>
              <v-card>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        :items="this.sourceGroups"
                        item-text="name"
                        item-value="id"
                        label="Source Group"
                        v-model="sourceGroupModel"
                        required
                        :disabled="this.inclusion != null"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        :items="this.targetGroups"
                        clearable
                        @click:clear="clearIncludedGroup()"
                        label="Included Group"
                        item-text="name"
                        item-value="id"
                        v-model="includedGroupModel"
                        color="primary"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-menu
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="displayStartDateTime"
                            label="Start Date"
                            persistent-hint
                            hint="Choose start date/time for card.  If no start date, click 'X' and clear field."
                            class="mr-1"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            clearable
                            @click:clear="clearStartDateTime()"
                          />
                        </template>
                        <v-card>
                          <!-- <v-date-picker v-model="displayStartDate" v-on:click:date="startDateMenu = false; startTimeMenu = true"></v-date-picker> -->
                          <v-date-picker v-model="displayStartDate">
                          </v-date-picker>
                          <v-time-picker
                            v-model="displayStartTime"
                            format="24hr"
                            @click:minute="startDateMenu = false;setStartDateTime()"
                          >
                          </v-time-picker>
                          <v-spacer></v-spacer>
                          <v-flex class="text-xs-right">
                            <v-btn text color="red" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="menu = false">OK</v-btn>
                          </v-flex>
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-menu
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="displayEndDateTime"
                            label="End Date"
                            persistent-hint
                            hint="Choose end date/time for card. If no end date, click 'X' and clear field."
                            class="ml-1"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            clearable
                            @click:clear="clearEndDateTime()"
                          />
                        </template>
                        <v-date-picker v-model="displayEndDate">
                        </v-date-picker>
                        <v-time-picker
                          v-model="displayEndTime"
                          format="24hr"
                          @click:minute="endDateMenu = false;setEndDateTime()"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
                <br />
              </v-card>
            </v-col>
          </v-row>
          <v-layout wrap>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <!-- <v-btn v-if="this.inclusion" color="blue darken-1"  :disabled="!valid" text @click="save">Save</v-btn> -->
            <v-btn v-if="this.editInclusion" color="blue darken-1" :disabled="!formValid" @click="save">Save</v-btn>
          </v-layout>
        </v-container>
      </template>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')
let mh = require('@/components/APIs/MessageHandler')

export default {
  props: {
    inclusion: {
      type: Object,
      required: true
    },
    sourceGroups: {
      type: Array,
      required: true
    },
    targetGroups: {
      type: Array,
      required: true
    },
    itemKey: {
      type: Number,
      required: false
    }
  },
  data: () => ({
    min: 0,
    max: 10,
    editInclusion: [],
    startDateMenu: null,
    startTimeMenu: null,
    endDateMenu: false,
    endTimeMenu: false,
    dateTimeDialog: false,
    e7: null,
    dialog: false,
    displaySource: null,
    displayIncluded: null,
    displayStartDate: null,
    displayStartTime: null,
    displayStartDateTime: null,
    displayEndDate: null,
    displayEndTime: null,
    displayEndDateTime: null,
    sourceGroupModel: null,
    includedGroupModel: null,
    newInclusion: false,
    defaultInclusion: {
      sourceGroup: {
        id: 0,
        name: null
      },
      includedGroup: {
        id: 0,
        name: null
      },
      createdDate: moment(new Date()).toISOString(),
      startDate: null,
      endDate: null
    },
    originalStartDate: null,
    originalEndDate: null,
    originalIncludedId: 0
  }),
  created () {
    // this.initialize()
  },
  mounted () {
    this.initialize()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    inclusion: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        if (!newValue || newValue === 'undefined') {
          this.newInclusion = true
          this.editInclusion = JSON.parse(JSON.stringify(this.defaultInclusion))
        } else {
          this.newInclusion = false
          this.editInclusion = JSON.parse(JSON.stringify(newValue))
        }
        this.setupEdit()
      }
    },
    dateTimeDialog (val) {}
  },
  computed: {
    formValid () {
      // check if source is set
      if (this.sourceGroupModel === 0) {
        return false
      }
      // make sure the source and included group are not the same
      if (this.includedGroupModel === this.sourceGroupModel) {
        return false
      }
      // check if data has changed
      var includedIdUnchanged = (this.originalIncludedId === this.includedGroupModel)
      var startDateUnchanged = (this.originalStartDate === this.displayStartDateTime)
      var endDateUnchanged = (this.originaEndDate === this.displayEndDateTime)

      if (this.inclusion != null) {
        if (includedIdUnchanged && startDateUnchanged && endDateUnchanged) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    initialize () {
    },
    clearIncludedGroup () {
      this.includedGroupModel = null
    },
    close () {
      delete this.editInclusion
      this.$emit('close-inclusion')
    },
    async save () {
      var response
      var request = {}
      var newInclusion = true
      if (this.editInclusion != null && this.editInclusion.id != null) {
        request.id = this.editInclusion.id
        newInclusion = false
      }
      request.sourceGroupId = this.sourceGroupModel
      if (this.includedGroupModel !== undefined && this.includedGroupModel !== 0) {
        request.includedGroupId = this.includedGroupModel
      }
      if (this.displayStartDateTime) {
        request.startDate = this.displayStartDate + 'T' + this.displayStartTime
      }
      if (this.displayEndDateTime) {
        request.endDate = this.displayEndDate + 'T' + this.displayEndTime
      }

      var incEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups/inclusions`
      // If doesn't contain inclusion, it's a new card
      if (newInclusion) {
        response = await rh.default.post(incEndpoint, request, true).catch(e => {
          this.errors.push(e)
        })
      } else {
        response = await rh.default.put(incEndpoint, request, true).catch(e => {
          this.errors.push(e)
        })
      }

      this.$emit('save-inclusion', JSON.stringify(response.data))
    },
    setStartDateTime () {
      var date = moment(
        this.displayStartDate + ' ' + this.displayStartTime
      )
      this.displayStartDateTime = this.formatDateTime(date)
    },
    clearStartDateTime () {
      this.localDate = null
      this.displayStartDate = ''
      this.displayStartTime = ''
      this.displayStartDateTime = ''
    },
    clearEndDateTime () {
      this.localDate = null
      this.displayEndDate = ''
      this.displayEndTime = ''
      this.displayEndDateTime = ''
    },
    setEndDateTime () {
      var date = moment(
        this.displayEndDate + ' ' + this.displayEndTime
      )
      this.displayEndDateTime = this.formatDateTime(date)
    },
    async setupEdit () {
      if (!this.editInclusion) {
        this.editIncusion = this.defaultInclusion
      }
      this.sourceGroupModel = this.editInclusion.sourceGroup.id
      if (this.editInclusion.includedGroup && this.editInclusion.includedGroup !== undefined) {
        this.includedGroupModel = this.editInclusion.includedGroup.id
      }

      this.displayStartDate = this.formatDate(this.editInclusion.startDate)
      this.displayStartTime = this.formatTime(this.editInclusion.startDate)
      this.displayStartDateTime = this.formatDateTime(this.editInclusion.startDate)
      this.localDate = !this.editInclusion.endDate ? null : moment(this.editInclusion.endDate)
      this.displayEndDate = this.formatDate(this.localDate)
      this.displayEndTime = this.formatTime(this.localDate)
      this.displayEndDateTime = this.formatDateTime(this.localDate)

      this.originalStartDate = this.displayStartDateTime
      this.originalEndDate = this.displayEndDateTime
      this.originalIncludedId = this.includedGroupModel
    },
    formatDateTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD HH:mm')
    },
    formatDate (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD')
    },
    formatTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('HH:mm')
    }
  }
}
</script>
<style>
.onlyDigitInput input[type="number"] {
  -moz-appearance: textfield;
}
.onlyDigitInput input::-webkit-outer-spin-button,
.onlyDigitInput input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
